"use client";

import React from "react";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import type { PullToRefreshProps } from "./types";

/**
 * PullToRefresh 组件
 * 下拉刷新时的展示组件
 */
export const PullToRefresh: React.FC<PullToRefreshProps> = ({
  className,
  // text,
  isRefreshing,
  progress,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-1 py-2",
        className,
      )}
    >
      {/* 刷新图标 */}
      <div className="shrink-0 w-5 h-5 flex items-center justify-center overflow-clip">
        <Icon
          name="ic_loading2"
          size={20}
          className={cn({
            "animate-spin": isRefreshing,
            "rotate-[var(--progress-angle)]": !isRefreshing,
          })}
          color={ospThemes.colors.content_tertiary}
          style={{
            "--progress-angle": `${progress * 360}deg`,
          }}
        />
      </div>
      {/* 文本内容 */}
      {/* <p className="body_m text-content_tertiary">{text}</p> */}
    </div>
  );
};
